import { metricsServerApi } from '../../modules/servers/api'
import { RawTeamData } from '../teams'
import { addPublishedFlightId } from './slice'
import { RawMatchState } from './types'

export const matchApi = metricsServerApi.injectEndpoints({
  endpoints: (builder) => ({
    getMatchState: builder.query<RawMatchState, void>({
      providesTags: ['matchState'],
      query: () => {
        return {
          url: '/matchState',
          method: 'GET',
          withCredentials: true
        }
      }
    }),

    changePossession: builder.mutation<RawMatchState, RawTeamData>({
      query: (body) => ({
        url: '/matchState/changePossession',
        method: 'POST',
        body,
        withCredentials: true
      })
    }),

    switchTeamSides: builder.mutation<RawMatchState, void>({
      query: () => ({
        url: `/matchState/switchTeamSides`,
        method: 'POST',
        body: {},
        withCredentials: true
      })
    }),

    updateBroadcasting: builder.mutation<any, boolean>({
      query: (data) => ({
        url: `/matchState/broadcasting/${data ? 'enable' : 'disable'}`,
        method: 'POST',
        withCredentials: true
      })
    }),

    manualPublish: builder.mutation<void, string>({
      query: (eventId) => ({
        url: `/matchState/manualPublish/${eventId}`,
        method: 'PUT',
        body: {},
        withCredentials: true
      }),
      async onQueryStarted(eventId, { dispatch, queryFulfilled }) {
        // After successful manual publish, add the eventId to publishedFlights to avoid duplicate publishes //
        try {
          await queryFulfilled
          dispatch(addPublishedFlightId(eventId))
        } catch (error) {
          console.error('Error fetching broadcast state:', error)
        }
      }
    }),

    // Set ball in play
    setBallInPlay: builder.mutation<void, string>({
      query: (ballId) => ({
        url: `matchState/ballInPlay/${ballId}`,
        method: 'POST',
        body: {},
        withCredentials: true
      })
    }),
    undoTimingStart: builder.mutation<void, void>({
      query: () => ({
        url: `matchState/undoTimingStart`,
        method: 'POST',
        body: {},
        withCredentials: true
      })
    }),
    undoTimingEnd: builder.mutation<void, void>({
      query: () => ({
        url: `matchState/undoTimingEnd`,
        method: 'POST',
        body: {},
        withCredentials: true
      })
    })
  })
})

export const {
  useGetMatchStateQuery,
  useUndoTimingStartMutation,
  useUndoTimingEndMutation,
  useLazyGetMatchStateQuery,
  useChangePossessionMutation,
  useSwitchTeamSidesMutation,
  useUpdateBroadcastingMutation,
  useManualPublishMutation,
  useSetBallInPlayMutation
} = matchApi
